type ExecuteRecaptcha = ((action: string) => Promise<string | null | undefined>) | undefined;

export const EDUCATION_SEARCH_RECAPTCHA_ACTION = "educationSearch";
export const LOCAL_RECAPTCHA_BYPASS_TOKEN = "local-dev-recaptcha-bypass";

export async function getEducationSearchRecaptchaToken(executeRecaptcha: ExecuteRecaptcha) {
  if (!executeRecaptcha) {
    if (process.env.NODE_ENV !== "production") {
      return LOCAL_RECAPTCHA_BYPASS_TOKEN;
    }

    throw new Error("RecaptchaUnavailable");
  }

  try {
    const token = await executeRecaptcha(EDUCATION_SEARCH_RECAPTCHA_ACTION);
    if (token) {
      return token;
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      return LOCAL_RECAPTCHA_BYPASS_TOKEN;
    }

    throw error;
  }

  if (process.env.NODE_ENV !== "production") {
    return LOCAL_RECAPTCHA_BYPASS_TOKEN;
  }

  throw new Error("Invalid reCAPTCHA token.");
}